export const FORM_CONSTANTS = {
  SOURCE_SYSTEM: 'im-website',
  ENDPOINT_URL: '/api/forms/SendConnect',
  RECAPTCHA_ACTION: 'submit_form',
  RECAPTCHA_MINIMUM_SCORE: 0.8,
};

export const CONVEYANCING_CALCULATOR_CONSTANTS = {
  ENDPOINT_URL: '/api/forms/SendConveyancingQuote',
  /** reCAPTCHA v3 action; must match client `executeRecaptcha` and SendConveyancingQuote verification */
  RECAPTCHA_ACTION: 'conveyancing_calc_submit',
};

export const WILLS_FORM_CONSTANTS = {
  ENDPOINT_URL: '/api/forms/SendWillInfo',
  /** reCAPTCHA v3 action name; must match client `executeRecaptcha` and server verification */
  RECAPTCHA_ACTION: 'online_will_submit',
  DISTRIBUTION_STEP_ID: 'step-8-4-estate-beneficiaries-distribution',
  DISTRIBUTION_FIELD_ID: 'estateDistributionPreference',
  DISTRIBUTION_ERROR_MESSAGE: 'At least one beneficiary must be added.',
};

export const DAY_ORDER: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DAY_ABBR_TO_FULL: Record<string, string> = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Tues: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Thur: 'Thursday',
  Thurs: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

export const DICTIONARY_KEYS = {
  REPORTS_AND_INSIGHTS_LIST: {
    LOAD_MORE: 'LoadMore',
    LOADING: 'Loading',
    READ_MORE: 'ReadMore',
  },
  ARTICLE_SEARCH: {
    READ_MORE: 'ReadMore',
    SEARCH_PLACEHOLDER: 'SearchArticles',
    NO_RESULTS: 'NoResultsFound',
    RESULT: 'Result',
    RESULTS: 'Results',
  },
};

export const SEARCH_CONSTANTS = {
  pageUrl: '/search',
};

export const REMIXICON_CONSTANTS = {
  spriteImageUrl: `${process.env.PUBLIC_URL || ''}/icons/sprites/remixicon.symbol.svg`,
};

export const TRUSTPILOT_CONSTANTS = {
  BUSINESS_UNIT_ID: '5477214300006400057bcbbd',
  DEFAULT_MAX_REVIEWS: 3,
  DEFAULT_MIN_STARS: 1,
  DEFAULT_REVIEW_CHARACTER_LIMIT: 100,
  DEFAULT_LANGUAGE: 'en',
};
